/**
 * Seat math for team invites. Pending invites reserve a seat so an owner
 * cannot send more invites than the plan allows.
 */

function showsTeamScreen(profile) {
  if (!profile) return false;
  return Boolean(profile.team_id || profile.is_team_owner || profile.subscription_plan === 'team');
}

function seatsOpen(team, pendingCount) {
  if (!team) return 0;
  const max = Number(team.max_seats);
  const used = Number(team.current_seats);
  const pending = Number(pendingCount) || 0;
  if (!Number.isFinite(max) || !Number.isFinite(used)) return 0;
  return max - used - pending;
}

function pendingInvitePhrase(pendingCount) {
  const pending = Number(pendingCount) || 0;
  if (pending === 1) return '1 invite pending';
  return `${pending} invites pending`;
}

function teamFullMessage(team, pendingCount) {
  const max = Number(team && team.max_seats) || 0;
  const pending = Number(pendingCount) || 0;
  const pendingNote = pending > 0 ? ` ${pendingInvitePhrase(pending)}.` : '';
  return `Team is full (${max} seats).${pendingNote} Remove a member or cancel an invite before adding more.`;
}

function seatDecision(team, pendingCount) {
  if (!team) return { ok: false, error: 'Your team is not ready yet.' };
  const open = seatsOpen(team, pendingCount);
  if (open <= 0) {
    return { ok: false, error: teamFullMessage(team, pendingCount) };
  }
  return { ok: true, open };
}

function validInviteEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
}

module.exports = {
  showsTeamScreen,
  seatsOpen,
  pendingInvitePhrase,
  teamFullMessage,
  seatDecision,
  validInviteEmail,
};
